import * as swal from 'sweetalert';
import * as _ from 'lodash';
import {AccountService} from "../../core/services/AccountService"
export class ProfilePageComponent implements ng.IComponentOptions {
    public controller: any = ProfileController;
    public template: string = /*html*/`
    <div class="container container-fluid">
        <breadcrumb tree="$ctrl.tree"></breadcrumb>
        <div class="wrapper row">
        <div class="col-md-3 sidebar">
          <div class="section-content">Update your account here.</div>
        </div>
        <div class="col-md-9">
        <h2>User Profile <button class="btn btn-default pull-right" ng-click="$ctrl.viewActivity()">Activity Stream</button></h2>
        <form name="regPsForm" class="form-horizontal form-ckan">
        <div class="form-group">
        <label for="name" class="col-sm-5 control-label">Full Name</label>
        <div class="col-sm-7">
          <input type="text" class="form-control" ng-model="$ctrl.form.fullname" id="name" placeholder="Full Name">
        </div>
        </div>
        <div class="form-group">
        <label for="inputEmail" class="col-sm-5 control-label">Email</label>
        <div class="col-sm-7">
          <input type="email" class="form-control" ng-model="$ctrl.account.email" id="inputEmail" placeholder="Email" disabled>
        </div>
        </div>
        <div class="form-group">
        <label for="contact" class="col-sm-5 control-label">Contact No</label>
        <div class="col-sm-7">
        <input type="text" class="form-control" ng-model="$ctrl.form.contact" id="contact" placeholder="Contact No">
        </div>
        </div>
        <div class="form-group" ng-show="$ctrl.account.usertype == 'external'">
        <label for="userType" class="col-sm-5 control-label">Type of User</label>
        <div class="col-sm-7">
        <ui-select ng-model="$ctrl.form.category">
        <ui-select-match placeholder="Select a User Type">
        <span ng-bind="$select.selected"></span>
        </ui-select-match>
        <ui-select-choices repeat="item in ($ctrl.userType | filter: $select.search)">
        <span ng-bind="item"></span>
        </ui-select-choices>
        </ui-select>
        </div>
        </div>
        <div class="form-group" ng-show="$ctrl.account.usertype == 'external_org'">
        <label for="orgName" class="col-sm-5 control-label">Organisation Name</label>
        <div class="col-sm-7">
        <input type="text" class="form-control" id="orgName" ng-model="$ctrl.form.organization.name" placeholder="Organisation Name">
        </div>
        </div>
        <div class="form-group" ng-show="$sctrl.account.usertype == 'external_org'">
        <label for="orgType" class="col-sm-5 control-label">Type of Organisation</label>
        <div class="col-sm-7">
        <ui-select ng-model="$ctrl.form.organization.orgType">
        <ui-select-match placeholder="Select a Organisation Type">
        <span ng-bind="$select.selected"></span>
        </ui-select-match>
        <ui-select-choices repeat="item in ($ctrl.orgType | filter: $select.search)">
        <span ng-bind="item"></span>
        </ui-select-choices>
        </ui-select>
        </div>
        </div>
        <div class="form-group" ng-show="$ctrl.account.usertype == 'external'||$ctrl.account.usertype == 'external_org'">
        <label for="purpose" class="col-sm-5 control-label">Purpose</label>
        <div class="col-sm-7">
        <ui-select ng-model="$ctrl.form.purpose">
        <ui-select-match placeholder="Select a Purpose">
        <span ng-bind="$select.selected"></span>
        </ui-select-match>
        <ui-select-choices repeat="item in ($ctrl.purposes | filter: $select.search)">
        <span ng-bind="item"></span>
        </ui-select-choices>
        </ui-select>
        </div>
        </div>
        <div class="form-group">
        <label class="col-sm-5 control-label">API KEY</label>
        <div class="col-sm-7"><button class="btn btn-default" ng-hide="showKey" ng-click="showKey = true">Reveal</button><p style="margin:7px" ng-show="showKey">{{$ctrl.account.api_key}}</p></div>
        </div>
        <div class="checkbox">
          <label>
            <input type="checkbox" name="subscribe" ng-model="$ctrl.form.subscribe" > Notify me when there are new published statistics
          </label>
        </div>
        <h4>Update Password</h4>
        <hr/>
        <div class="form-group">
          <label for="oldPassword" class="col-sm-5 control-label">Old Password</label>
          <div class="col-sm-7">
          <input type="password" class="form-control" ng-model="$ctrl.form.old_password" placeholder="Old Password"/>
          </div>
        </div>
        <div class="form-group">
          <label for="oldPassword" class="col-sm-5 control-label">New Password</label>
          <div class="col-sm-7">
          <input type="password" class="form-control" ng-model="$ctrl.form.new_password" placeholder="New Password"/>
          <ng-password-meter password="$ctrl.form.new_password" strength="$ctrl.strength"></ng-password-meter>
          </div>
        </div>
        <div class="form-group">
          <label for="oldPassword" class="col-sm-5 control-label">Repeat New Password</label>
          <div class="col-sm-7">
          <input type="password" class="form-control" ng-model="$ctrl.form.repeat_password"  placeholder="Repeat New Password"/>
          <span class="text-warning" ng-show="$ctrl.error.password">Password not Match!</span>
          </div>
        </div>
        </form>

        <div class="control-panel">
        <button class="btn btn-primary pull-right" ng-click="$ctrl.update()" ng-disabled="$ctrl.submitting">Update Account</button>
        </div>
        </div>
        </div>
    </div>`;
}
export class ProfileController {
    public static $inject: Array<string> = ["AccountService", "$uibModal", "$state", "$anchorScroll"];
    public tree: Array<Object>;
    public userType: Array<String>;
    public orgType: Array<String>;
    public purposes: Array<String>;
    public submitting: Boolean;
    public regSuccess: Boolean;
    public regEmail: String;
    public form: any;
    public error: any;
    public strength: number;

    constructor(public account: AccountService, private $uibModal: ng.ui.bootstrap.IModalService, private $state: ng.ui.IStateService, private $anchorScroll: ng.IAnchorScrollService) {
      this.tree = [
        {name: "User Profile", path: "#/profile", active: true}
      ];
      this.userType = [
        "Student","Lecturer","Research"
      ];
      this.orgType = [
        "University", "Resarch Center"
      ];
      this.purposes = [
        "Assignment", "Research"
      ];
      this.error = {duplicated: false}

    }

    public $onInit() {
      this.account.$promise.then(d => {
        this.form = {
          fullname: d.fullname,
          contact: d.contact,
          category: d.category,
          organization: d.organization,
          purpose: d.purpose,
          subscribe: d.subscription.indexOf('published') > -1
        };
      })
      this.$anchorScroll();
    }

    public update() {
      if (this.form.old_password && this.form.new_password && this.form.new_password !== this.form.repeat_password) {
        this.error.password = true;
        return;
      }
      if (this.form.old_password && this.form.new_password && this.strength < 50) {
        swal("Sorry!", "Please use stronger password", "warning");
        return;
      }
      this.form.subscription = this.account.subscription
      if (this.form.subscribe) {
        if (this.account.subscription.indexOf('published') === -1)
          this.form.subscription.push('published')
      }
      else {
        this.form.subscription = _.pull(this.account.subscription, 'published')
      }
      this.submitting = true;
      this.account.updateMe(this.form).then((d:any) => {
        this.submitting = false;
        this.form.old_password = "";
        this.form.new_password = "";
        this.form.repeat_password = "";
        this.error = {};
        swal({
          title: "Success!",
          text: "Profile Updated",
          type:"success"}, () => {
            location.reload();
          });
      })
      .catch(err => {
        this.submitting = false;
        if (err.data.code && err.data.code === 100) {
          swal("Oops!", "You have enter the wrong password", "warning");
        }
        else
          swal("Sorry!", "Something went wrong, please try it again", "warning");
      });
    }

    public resetForm() {
      this.form = {};
    }

    public viewActivity() {
      let _modalInstance = this.$uibModal.open({
        component: 'activityModal',
        windowClass: 'square-modal',
        resolve: {
          userId: () => {
            return this.account._id;
          }
        }
      });
      _modalInstance.result.then((d) => {

      })
    }

}
